<template>
  <div class="center">
    <div>
      <video
        :id="`myVideo${index}`"
        class="video-js vjs-default-skin"
        playsinline
      ></video>
      <div
        v-show="recordStart"
        :class="{ textTimer: timerPlay < 0 ? true : false }"
        class="timerCount"
      >
        {{ timerPlay >= 0 ? timerPlay : "GRAVANDO" }}
      </div>
    </div>
    <div class="control-video">
      <button
        v-if="
          !isRecord ||
          (!isRecord && timerPlay > 3 && retakers < question.number_retakers)
        "
        @click="startRecord"
        :disabled="recordStart"
        type="button"
        class="btn mt-5 mb-3 btn-primary btn-lg mr-1"
      >
        {{ retakers == 0 ? "COMEÇAR A GRAVAR" : "REGRAVAR VÍDEO" }}
      </button>

      <button
        @click="stopRecord"
        v-if="isRecord"
        class="btn btn-lg mt-5 mb-3 btn-danger"
      >
        PARAR GRAVAÇÃO
      </button>
    </div>
  </div>
</template>

<script>
import "webrtc-adapter";

import videojs from "video.js";

import Record from "videojs-record/dist/videojs.record.js";
import axios from "axios";
export default {
  props: [
    "video",
    "gallery",
    "item",
    "reference_id",
    "index",
    "question",
    "name",
  ],
  data() {
    return {
      question_id: 0,
      index_current: 0,
      isRecord: false,
      recordStart: false,
      timerStart: "",
      timerPlay: 4,
      player: "",
      retakers: 0,
      loadding: false,
      options: {
        controls: true,
        autoplay: false,
        loop: false,
        fluid: true,
        controlBar: {
          deviceButton: false,
          recordIndicator: false,
          fullscreenToggle: false,
          volumePanel: false,
          cameraButton: false,
          pipToggle: true,
          recordToggle: false,
        },
        plugins: {
          record: {
            image: false,
            audio: true,
            video: true,
            pip: true,
            debug: true,
            maxLength: 2,
            videoMimeType: "video/mp4",
          },
        },
      },
    };
  },
  watch: {
    timerPlay(val) {
      if (val == -2) {
        this.recordStart = false;
        clearInterval(this.timerStart);
        this.player.record().start();
        this.timerPlay = 4;
      }
    },
  },
  methods: {
    stopRecord() {
      this.player.record().stop();
      eventBus.$emit("stopSave", false);
    },
    startRecord() {
      this.timerPlay = 3;
      this.retakers++;
      this.recordStart = true;
      this.timerStart = setInterval(() => this.timerPlay--, 1000);
      if (this.question) {
        axios
          .post("/recruiters/templates/questions", {
            questions: {
              template_id: this.question.template_id,
              itens: [this.question],
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.question_id = response.data.question.id;
            }
          });
      }
      eventBus.$emit("stopSave", true);
    },
    getThumbnail(player) {
      let canvas = document.createElement("canvas");
      canvas.className = "hide";
      canvas.width = 480;
      canvas.height = 360;
      document.getElementsByTagName("body")[0].appendChild(canvas);

      // draw video frame
      let context = canvas.getContext("2d");
      context.drawImage(
        player.record().mediaElement,
        0,
        0,
        canvas.width,
        canvas.height
      );
      return canvas;
    },
    upload(blob) {
      this.loadding = true;
      let player = blob.recordedData;
      let canvas = this.getThumbnail(blob);
      let formData = new FormData();

      canvas.toBlob((thumb) => {
        formData.append("videos[thumbnail]", thumb);
        formData.append("videos[file]", player, player.name);
        let video_name = this.video.name;
        if (this.name) video_name = this.name;
        formData.append("videos[name]", video_name);
        formData.append("videos[description]", this.video.description);
        formData.append("videos[id]", this.video.video_id);

        formData.append(
          "galleries[gallery_category_id]",
          this.gallery.category_id
        );

        formData.append("galleries[reference_id]", this.gallery.reference_id);
        formData.append("galleries[name]", this.gallery.name);
        formData.append(
          "galleries[item_category_id]",
          this.gallery.item_category_id
        );
        formData.append("galleries[id]", this.gallery.id);
        formData.append("gallery_item[id]", this.item.id);
        formData.append("gallery_item[video_id]", this.item.video_id);
        let reference_id = 0;
        this.question_id !== 0
          ? (reference_id = this.question_id)
          : (reference_id = this.reference_id);
        if (reference_id)
          formData.append("gallery_item[reference_id]", reference_id);

        axios
          .post("/recruiters/galleries/videos?no_replace=true", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((resp) => {
            if (
              this.gallery.item_category_id == 5 &&
              this.gallery.reference_id != 0
            ) {
              this.$emit("setFieldGalleryItem", resp);
              return;
            }

            eventBus.$emit("setFieldVideo", {
              gallery_item: resp.data.gallery_item,
              video: resp.data.video,
            });
            eventBus.$emit("stopSave", false);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
  },
  mounted() {
    this.options.plugins.record.maxLength = 180;
    // }

    this.player = videojs(`#myVideo${this.index}`, this.options, () => {
      var msg = "";
      videojs.log(msg);
    });

    this.player.on("deviceReady", () => {});

    this.player.on("startRecord", () => {
      this.isRecord = true;
    });

    this.player.on("finishRecord", () => {
      this.isRecord = false;
      this.loadding = true;

      this.upload(this.player);
    });

    this.player.on("deviceError", () => {
      console.log("device error:", this.player.deviceErrorCode);
    });

    this.player.on("error", (element, error) => {
      console.log(error);
    });

    this.player.record().setVideoInput(MediaDeviceInfo.deviceId);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>